var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"main-footer"},[_c('div',{staticClass:"float-right d-none d-sm-inline-block"},[_c('b',[_vm._v("Version")]),_vm._v(" "+_vm._s(_vm.appVersion)+" "),(_vm.$store.state.gitVersion)?_c('span',[_vm._v("- "),_c('b',[_vm._v("Git")]),_vm._v(" "+_vm._s(_vm.$store.state.gitVersion))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }